import React, { useState } from 'react';
import Pagination from '../Pagination/Pagination';
import { useLocation } from 'react-router-dom';

const TableView = ({ handleOpenModal,DataAvailabe, handleDeleteDevice, SHOWSETTINGTAB, headers, rows, onRowSelectionChange, SHOWSETTINGTAB7, RESETData }) => {
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [pagefull, setPagefull] = useState(false);
  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const location = useLocation();

  const applySorting = (data) => {
    if (sortConfig.key) {
      return [...data].sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];
        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }
    return data;
  };

  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const currentData = applySorting(
    rows.filter((row) => {
      return Object.keys(filters).every((key) => {
        return row[key]?.toString().toLowerCase().includes(filters[key]?.toLowerCase() || '');
      });
    })
  ).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  React.useEffect(() => {
    if (location.pathname === "/api-settings") {
      setPagefull(true);
    }
  }, [location]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleRowSelect = (rowId) => {
    const newSelectedRows = new Set(selectedRows);
    if (newSelectedRows.has(rowId)) {
      newSelectedRows.delete(rowId);
    } else {
      newSelectedRows.add(rowId);
    }
    setSelectedRows(newSelectedRows);

    const selectedData = currentData.filter((_, index) => newSelectedRows.has(index));
    onRowSelectionChange(selectedData);
  };


const handleOpenedit =(data) =>{
  handleOpenModal(data);
}


  const handleSelectAll = (event) => {
    const allRowIds = event.target.checked ? new Set(currentData.map((_, index) => index)) : new Set();
    setSelectedRows(allRowIds);

    const selectedData = currentData.filter((_, index) => allRowIds.has(index));
    onRowSelectionChange(selectedData);
  };

 
// Data === false 
  if (DataAvailabe===false) return (
    <div className={`relative bg-DarkBlue h-screen overflow-hidden md:mt-0 ${pagefull && `mt-16`} md:mx-16 rounded-sm shadow-black shadow-xl`}>
    <div className={`overflow-x-scroll overflow-y-scroll mb-5 ${SHOWSETTINGTAB || SHOWSETTINGTAB7 ? 'h-[66vh]' : 'h-[73vh]'}`}>
      {/* Table */}
      <div className="flex items-center justify-center h-screen">
        <h1 className="text-xl font-semibold text-gray-400">No data found.</h1>
      </div>
      </div>
      </div>
  );



  // Data === false 
  if (rows.length === 0) return (
    <div className={`relative bg-DarkBlue h-screen overflow-hidden md:mt-0 ${pagefull && `mt-16`} md:mx-16 rounded-sm shadow-black shadow-xl`}>
    <div className={`overflow-x-scroll overflow-y-scroll mb-5 ${SHOWSETTINGTAB || SHOWSETTINGTAB7 ? 'h-[66vh]' : 'h-[73vh]'}`}>
      {/* Table */}
      <div className="flex items-center justify-center h-screen">
        <h1 className="text-xl font-semibold  text-yellow-500">No Task Availabe.</h1>
      </div>
      </div>
      </div>
  );
 

  return (
    <div className={`relative bg-DarkBlue h-screen overflow-hidden md:mt-0 ${pagefull && `mt-16`} md:mx-16 rounded-sm shadow-black shadow-xl`}>
      <div className={`overflow-x-scroll overflow-y-scroll mb-5 ${SHOWSETTINGTAB || SHOWSETTINGTAB7 ? 'h-[66vh]' : 'h-[73vh]'}`}>
        {/* Table */}
        <table className="w-full text-left text-white">
          <thead className="sticky z-30 top-0 bg-DarkBlue">
            <tr className="border-b border-gray-700 text-sm text-gray-400">
              <th className="p-3">
                <input
                  type="checkbox"
                  className={`w-5 h-5 border rounded-md transition duration-200 ease-in-out ${currentData.length > 0 && currentData.every((_, index) => selectedRows.has(index)) ? 'bg-red-500' : 'border-gray-400'
                    } appearance-none cursor-pointer relative`}
                  onChange={handleSelectAll}
                  checked={currentData.length > 0 && currentData.every((_, index) => selectedRows.has(index))}
                />
              </th>
              {headers.map((header, index) => (
                <th key={index} className="p-3 cursor-pointer relative" >
                  <span onClick={() => handleSort(header.key)}>
                  {header.label || header.key} {/* Use label or key if no label */}
                  {sortConfig.key === header.key && (
                    <span className="ml-2">{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>
                  )}
                  </span>
                  
                  <input
                    type="text"
                    placeholder="Filter"
                    value={filters[header.key] || ''}
                    onChange={(e) => {
                      e.stopPropagation(); // Prevent sorting when clicking inside the filter input
                      handleFilterChange(header.key, e.target.value);
                    }}
                    className={`mt-1 p-1 rounded bg-gray-700 text-gray-200 ${(typeof header.label !== 'string') && 'hidden'}`}
                  />
                </th>
              ))}

              <th className={`p-3 ${SHOWSETTINGTAB ? 'flex' : 'hidden'}`}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentData.map((row, rowIndex) => (
              <tr key={rowIndex} className="border-b border-gray-700 text-sm">
                <td className="p-3">
                  <input
                    type="checkbox"
                    className={`w-5 h-5 border-2 rounded transition duration-200 ease-in-out ${selectedRows.has(rowIndex) ? 'bg-red-500' : 'border-gray-400'
                      } appearance-none cursor-pointer relative`}
                    checked={selectedRows.has(rowIndex)}
                    onChange={() => handleRowSelect(rowIndex)}
                  />

                </td>
                
                {headers.map((header, colIndex) => (
  <td key={colIndex} className="p-3">
    {header.render 
      ? header.render(row) 
      : (row[header.key] !== undefined && row[header.key] !== null && row[header.key] !== '') 
        ? row[header.key] 
        : <span className='text-yellow-500'>Not Available</span> }
  </td>
))}

                <td className={`p-3 ${SHOWSETTINGTAB ? 'flex' : 'hidden'}`}>
                  <button
                    className="bg-blue-500 text-white px-2 py-1 rounded mr-2"
                    onClick={() => handleOpenedit(row)}
                  >
                    Update Firmware
                  </button>
                  
                </td>
                
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        totalPages={Math.ceil(rows.length / rowsPerPage)}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default TableView;
